//TODO: EVENTUALLY REFACTOR/RENAME THIS TO BE THE INTERVALSET ACCORDION CONTAINER

import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useEffect, useState, useRef } from "react";
import { useRowSelector, useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { navSliceActions } from "../../store/slices/NavSlice";
import SchedulingMatrix from "./SchedulingMatrix/SchedulingMatrix";
import ListItem from "@material-ui/core/ListItem";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import Tooltip from "@mui/material/Tooltip";
import IntervalModel from "../../models/communications/Interval";
// import IntervalSetModel from "../../../models/communications/IntervalSet";
import Interaction from "../../models/interactions/Interaction";
import InteractionNode, { CopyProps } from "../../models/interactions/InteractionNode";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { IconButton } from "@mui/material";
import GridOnIcon from "@mui/icons-material/GridOn";
import SaveIcon from "@mui/icons-material/Save";
import { enqueueSnackbar } from "notistack";

import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import { stateDeepCopy } from "../../helpers/DataUpdateHelper";
import useHttp from "../../hooks/useHttp";
import IntervalSetModel from "../../models/communications/IntervalSet";
import InteractionNodeInterval from "../../models/interactions/InteractionNodeInterval";
import IosShareIcon from "@mui/icons-material/IosShare";
import FolderCopyOutlinedIcon from "@mui/icons-material/FolderCopyOutlined";
import UserPermissions from "../../models/users/UserPermissions";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InteractionParentInterval from "../../models/interactions/InteractionParentInterval";
import CommunicationSet from "../../models/communications/CommunicationSet";
import InteractionPopoutButton from "../interactions/ui/InteractionPopoutButton";
import CircularProgress from '@mui/material/CircularProgress';
import InteractionDeleteButton from "../interactions/ui/InteractionDeleteButton";
import { useTranslation } from "react-i18next";
import MatrixControls from "./SchedulingMatrix/controls/MatrixControls";
import Interval from "../../models/communications/Interval";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { postgrest_operators } from "../../helpers/HttpHelper";
import InteractionDisabledOverlay from "../interactions/ui/InteractionDisabledOverlay";

// NOTE: THIS IS ONLY BEING USED FOR INTERVAL SETS RIGHT NOW
// FOR POST-MVP IT SHOULD BE RE-CONFIGURED TO SUPPORT GROUPS OF WIDGETS
export interface IntervalSetProps {
  interactionNode?: InteractionNode | null | undefined;
  childInteractions: Array<any>;
  associatedIntervals: Array<any>;
  associatedCommSets: Array<CommunicationSet>;
  interaction: Interaction;
  intervalSet: IntervalSetModel;
  currentParent: number;
  currentSet: number;
  associatedInteractionNodeIntervals: Array<InteractionNodeInterval>;
  associatedInteractionNodes: Array<InteractionNode>;
  associatedInteractions: Array<Interaction>;
  interactionParentIntervals: Array<InteractionParentInterval>;
  isReferenceSet: boolean;
  handleDeleteInteraction: any;
}

const IntervalSet = (props: IntervalSetProps) => {
  const intervalSet = useRowSelector(IntervalSetModel, props.intervalSet.id);
  const correspondingInteraction = useRowSelector(Interaction, props.interaction.id);

  const accordionRef = useRef(null); // Ref for the AccordionSummary
  const [expanded, setExpanded] = useState<string | false>("");
  let editModeDefault = true;
  if (props.intervalSet.name) {
    editModeDefault = false;
  }
  // if set is shared, edit mode should be off (locked) by default
  // otherwise if its anonymous it should be unlocked and all controls available
  const [editMode, setEditMode] = useState<boolean>(intervalSet?.shared ? false : true);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { t } = useTranslation()

  const dispatch = useStoreDispatch();


  const handleIntervalSetSave = async (deletedObjects?: Array<any> | null) => {
    if (typeof deletedObjects === 'undefined') {
      deletedObjects = null;
    }
    try {
      await intervalSet?.save();
      const message = "Successfully saved Interval Set " + intervalSet?.id
      enqueueSnackbar(message, { variant: "success" });
    } catch (err: any) {
      if (typeof err === "string") {
        enqueueSnackbar(err, { variant: "error" });
      } else if (typeof err.message === "string") {
        enqueueSnackbar(err.message, { variant: "error" });
      } else {
        enqueueSnackbar("Unknown Error Occurred", { variant: "error" });
      }
    }

  }

  const handleOpenIntervalSet = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500)
  }

  // Function to programmatically click the AccordionSummary
  const programmaticallyClickAccordion = () => {
    if (accordionRef.current) {
      accordionRef.current.click(); // Dispatch a click event
    }
  };

  // Automatically click the AccordionSummary on component mount to trigger loading of children
  useEffect(() => {
    programmaticallyClickAccordion();
  }, []);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
      handleOpenIntervalSet()
    };

  const rightDrawerOpen = useStoreSelector(
    (state) => state.nav.rightDrawerOpen,
  );

  function handleOpenEdit() {
    dispatch(
      navSliceActions.openRightDrawer({
        content: props.intervalSet,
        type: "intervalSets",
        resourceName: "interval_set",
        resourceID: props.intervalSet.id,
        extraData: {
          interaction: props.interaction
        },
      }),
    );
  }

  const shareButtonSx: any = { float: "right" };
  let intervalSetNameStyle: any = {};
  let intervalSetNameTooltipText = "";
  let intervalSetShareTooltipText =
    "Share";

  if (props.intervalSet.name) {
    //  shareButtonSx = { float: "right", color:"red" };
    intervalSetNameStyle = { color: "#1976d2" };
    intervalSetNameTooltipText =
      "This Interval Set has been made standard and is potentially being used on other Pathways";
    intervalSetShareTooltipText =
      editMode ? "Lock Interval Set" : "Click to unlock Interval Set edit tools";
  }

  const style = {
    display: 'flex',
    border: "1px solid lightskyblue",
    borderRadius: "5px",
    height: "40px",
    alignItems: 'center',
    justifyContent: 'flex-start', // Ensure content is aligned to the start
    '& .MuiAccordionSummary-expandIconWrapper': {
      order: -1, // Move the expand icon to the left
      marginRight: 'auto', // Add some space between the icon and the text/content
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: '16px', // Add some space to compensate for the icon being on the left
    },
  };

  return (
    <div data-testid={props.intervalSet.id} style={{ padding: "10px 65px" }}>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          ref={accordionRef}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={style}
        >
          <ListItem>
            <Tooltip title="Interval Set" placement="top">
              <GridOnIcon
                sx={{
                  color: props.intervalSet.name ? "#1976d2" : "gray",
                  float: "left",
                  fontSize: "1.5em",
                  display: "inline-block",
                  marginRight: "20px",
                }}
              />
            </Tooltip>
            <Tooltip title={intervalSetNameTooltipText}>
              <h4
                data-testid={props.intervalSet.name}
                style={intervalSetNameStyle}
              >
                {!props.intervalSet.name && <span>&nbsp;</span>}
                {props.intervalSet.name && props.intervalSet.name}

              </h4>
            </Tooltip>
            {/* For now, we will continue to open drawer to update commset name and make it shareable */}
            {props.intervalSet.name === null && !props.intervalSet.shared && (
              <Tooltip title={intervalSetShareTooltipText}>
                <IconButton
                  data-testid="editIntervalSetButton"
                  disabled={props.intervalSet.name !== null}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenEdit();
                  }}
                >
                  <IosShareIcon sx={shareButtonSx} />
                </IconButton>
              </Tooltip>
            )}

            {props.intervalSet.shared && <Tooltip title={intervalSetShareTooltipText}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setEditMode(!editMode);
                }}
              >
                {!editMode && <LockIcon style={{ color: "red" }} />}
                {editMode && <LockOpenIcon style={{ color: "#1976d2" }} />}
              </IconButton>
            </Tooltip>}
            &nbsp;
          </ListItem>

          {/* this content will show on the RIGHT side of the accordion bar */}
          {editMode && props.intervalSet.shared && (
           <span style={{ color: "red"}}>
                      <h6 style={{ color: "red"}}>
                      <span style={{marginTop: "-15px"}}>
                        <ErrorOutlineOutlinedIcon />
                      </span>
                        Editing shared content!
                      </h6>
                    </span>
          )}

          {props.intervalSet.shared && (
            <Tooltip title="Convert to Copy">
              <IconButton
                data-testid="editIntervalSetButton"
                //disabled={!editMode}
                onClick={ async (e) => {
                  dispatch(
                    navSliceActions.openModal({
                      caresenseModalAlertType: "interval_set_copy",
                      caresenseModalAlertMessage: "This action will replace this shared entity with an anonymous copy of it. Proceed?",
                      caresenseModalAlertEntityID: props.intervalSet.id,
                      modalCallback: async () => {
                        // to copy interval set,
                        // we simply want to copy the interval set and its intervals/commsets to new anon ids (if not shared)
                        // and then return the top level new interval_set.id
                        // use that to update the properties of THIS CORRESPONDING INTERACTION 
                        // and replace which interval set is referenced there
                        // (The original shared one will still exist to search for if needed)
                        e.stopPropagation();
                        const copiedIDsMap :CopyProps = await intervalSet?.copy();
                        const intervalSetIDIndex = "" + intervalSet?.id || "0";
                        const newIntervalSetID = copiedIDsMap.interval_set[intervalSetIDIndex];
      
                        const thisInteractionProperties = correspondingInteraction?.properties;
                        if (thisInteractionProperties) {
                          thisInteractionProperties.intervalSetID = newIntervalSetID;
                          console.log(thisInteractionProperties)
                          const updatedCorrespondingInteraction = correspondingInteraction?.update("properties",thisInteractionProperties);
                          updatedCorrespondingInteraction?.save()
                          // pull new intervalset into redux
                          // const thisNewCommSetResults = await IntervalSetModel.queryTable([
                          //   {
                          //     column: "id",
                          //     operator: postgrest_operators.eq,
                          //     value: newIntervalSetID.toString(),
                          //   },
                          // ]);
                        }
                        // just reload screen for now
                        window.location.reload();
      
      
                        //handleOpenEdit();
                        } // post callback to redux so modal alert calls it on user approval
                    }),
                  );

                }}
              >
                <CopyAllIcon />
              </IconButton>
            </Tooltip>
          )}
          {props.interactionNode && (
            <InteractionPopoutButton
              interaction={props.interaction}
              interactionNode={props.interactionNode}
              setID={props.interactionNode.set_interaction_id}
              parentID={props.interactionNode.parent_interaction_id}
              isInitial={false}
              isReferenceSet={props.isReferenceSet}
            />
          )}
          {props.interactionNode && (
            <InteractionDeleteButton
              disabled={!editMode}
              handler={props.handleDeleteInteraction}
              interaction={props.interaction}
            />
          )}
          <MatrixControls
            intervalSetID={props.intervalSet.id}
            associatedIntervals={props.associatedIntervals}
            associatedInteractionNodeIntervals={props.associatedInteractionNodeIntervals}
            associatedInteractionNodes={props.associatedInteractionNodes}
            associatedInteractions={props.associatedInteractions}
            editMode={editMode}
            intervalSetName={props.intervalSet.name}
            addNewIntervalToIntervalSet={Interval.addNewInterval}
            inAccordionSummary={true}
          />
        </AccordionSummary>
        <AccordionDetails>
          {intervalSet?.shared && <InteractionDisabledOverlay type = "interval_set" isVisible={!editMode}/>}
          {isLoading && <div style={{ textAlign: "center" }}><CircularProgress /></div>}
          {!isLoading && <SchedulingMatrix
            intervalSetID={props.interaction.properties.intervalSetID || -1}
            childInteractions={props.childInteractions}
            associatedIntervals={props.associatedIntervals}
            associatedCommSets={props.associatedCommSets}
            currentParent={props.currentParent}
            currentSet={props.currentSet}
            editMode={editMode}
            intervalSetName={props.intervalSet.name}
            intervalSet={props.intervalSet}
            associatedInteractionNodeIntervals={
              props.associatedInteractionNodeIntervals
            }
            associatedInteractionNodes={props.associatedInteractionNodes}
            associatedInteractions={props.associatedInteractions}
            interactionParentIntervals={props.interactionParentIntervals}
            intervalSetSaveHandler={handleIntervalSetSave}
          // firstOrdinal={1}
          // lastOrdinal={1}
          />}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
export default IntervalSet;
